import React from 'react';

const PaginationSection = ({ page, pages, setPage }) => {
  if (pages <= 1) return null;

  const renderPageNumbers = () => {
    const pageNumbers = [];
    
    if (pages <= 7) {
      for (let i = 1; i <= pages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1);
      
      let start = Math.max(2, page - 1);
      let end = Math.min(pages - 1, page + 1);
      
      if (page <= 3) {
        end = 4;
      } else if (page >= pages - 2) {
        start = pages - 3;
      }
      
      if (start > 2) {
        pageNumbers.push('ellipsis-start');
      }
      
      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }
      
      if (end < pages - 1) {
        pageNumbers.push('ellipsis-end');
      }
      
      pageNumbers.push(pages);
    }
    
    return pageNumbers.map((p, idx) => {
      if (p === 'ellipsis-start' || p === 'ellipsis-end') {
        return (
          <li key={`ellipsis-${idx}`} className="page-item disabled">
            <span className="page-link border-0 bg-transparent text-muted px-2">...</span>
          </li>
        );
      }
      return (
        <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
          <button className="page-link page-circle-btn" onClick={() => setPage(p)}>
            {p}
          </button>
        </li>
      );
    });
  };

  return (
    <nav className="d-flex justify-content-between align-items-center mt-4 px-2">
      <div className="small text-muted font-weight-medium">
        Page <span className="text-dark font-weight-bold">{page}</span> of <span className="text-dark font-weight-bold">{pages}</span>
      </div>
      <ul className="pagination custom-pagination mb-0">
        {/* First Page Shortcut */}
        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
          <button className="page-link page-circle-btn" onClick={() => setPage(1)} title="First Page">
            «
          </button>
        </li>
        {/* Previous Page */}
        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
          <button className="page-link page-circle-btn" onClick={() => setPage(page - 1)} title="Previous Page">
            ‹
          </button>
        </li>
        
        {/* Page Numbers */}
        {renderPageNumbers()}
        
        {/* Next Page */}
        <li className={`page-item ${page === pages ? 'disabled' : ''}`}>
          <button className="page-link page-circle-btn" onClick={() => setPage(page + 1)} title="Next Page">
            ›
          </button>
        </li>
        {/* Last Page Shortcut */}
        <li className={`page-item ${page === pages ? 'disabled' : ''}`}>
          <button className="page-link page-circle-btn" onClick={() => setPage(pages)} title="Last Page">
            »
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default PaginationSection;
